import Blue from "~/core";
import Swiper, { Navigation, Pagination } from "swiper";

Swiper.use([Navigation, Pagination]);

new Blue({
  name: "Case Studies Slider",
  selector: ".case-studies--default",
  setup(caseStudies) {
    let maxIndexEl = caseStudies.querySelector(".swiper-max-index");
    const random = Math.ceil(Math.random() * 10000);
    const swiperContainer = caseStudies.querySelector(".swiper-container");

    swiperContainer.classList.add(`swiper-${random}`);
    let swiper = new Swiper(
      ".swiper-" + random,
      {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 10,
        slideToClickedSlide: true,
        observer: true,
        observeParents: true,
        threshold: 100,
        thresholdDelta: 100,
        thresholdTime: 500,
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        breakpoints: {
          
          768: {
            slidesPerGroup: 1,
          },
          968: {
            slidesPerGroup: 1,
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          resize: function() {
            setTimeout(() => maxIndexEl.innerHTML = this.slides.length, 500);
          },
          init: function () {
            let maxSlides = this.slides.length;
            let pages = maxSlides / this.params.slidesPerGroup;
            maxIndexEl.innerHTML = Math.round(pages + 0.4);
            if(pages <= 1){
              let swiperPageContainer = caseStudies.querySelector('.swiper-navigation')
              swiperPageContainer.style.display = "none"
            }
          },
        },
      },
      false
    );
  },
});
